import { Link } from "react-router-dom";
import RouteUrl from '../RouteEnum';
import './Page.css';
import { checkRU } from '../../index';

const Error404Page = () => {
    const { isRu, apiUrl } = checkRU();
    return (
        <div className="frame">
            <h1 className="main-header">Error 404</h1>
            <div>{isRu ? "Страница не найдена" : "Сторінку не знайдено"}</div>
            <Link to={isRu ? RouteUrl.ru : RouteUrl.index} >{isRu ? "На главную" : "На головну"}</Link>
        </div>
    );
}

export default Error404Page;